import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="delayed-hide"
// Hides the element after a configurable delay when connected
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 500 }
  }

  connect() {
    setTimeout(() => {
      this.element.classList.add("hidden")
    }, this.delayValue)
  }
}
